import { render } from "./orderdetail.vue?vue&type=template&id=5d732a14&scoped=true"
import script from "./orderdetail.vue?vue&type=script&lang=js"
export * from "./orderdetail.vue?vue&type=script&lang=js"

import "./orderdetail.vue?vue&type=style&index=0&id=5d732a14&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d732a14"]])

export default __exports__